import { fetchList } from '@bit/knotchinc.web-react-components.utils.fetch-actions';
import { brands, keywords, publishers, content } from 'api';

export const TOGGLE_SEARCH_PREVIEW = 'TOGGLE_SEARCH_PREVIEW';

// export const FETCH_SEARCH_PREVIEW = 'FETCH_SEARCH_PREVIEW';
// export const FETCHED_SEARCH_PREVIEW = 'FETCHED_SEARCH_PREVIEW';

export const FETCH_SEARCH_PREVIEW_KEYWORDS = 'FETCH_SEARCH_PREVIEW_KEYWORDS';
export const FETCHED_SEARCH_PREVIEW_KEYWORDS = 'FETCHED_SEARCH_PREVIEW_KEYWORDS';
export const SET_SEARCH_PREVIEW_KEYWORDS_FILTER = 'SET_SEARCH_PREVIEW_KEYWORDS_FILTER';

export const FETCH_SEARCH_PREVIEW_BRANDS = 'FETCH_SEARCH_PREVIEW_BRANDS';
export const FETCHED_SEARCH_PREVIEW_BRANDS = 'FETCHED_SEARCH_PREVIEW_BRANDS';
export const SET_SEARCH_PREVIEW_BRANDS_FILTER = 'SET_SEARCH_PREVIEW_BRANDS_FILTER';

export const FETCH_SEARCH_PREVIEW_PUBLISHERS = 'FETCH_SEARCH_PREVIEW_PUBLISHERS';
export const FETCHED_SEARCH_PREVIEW_PUBLISHERS = 'FETCHED_SEARCH_PREVIEW_PUBLISHERS';
export const SET_SEARCH_PREVIEW_PUBLISHERS_FILTER = 'SET_SEARCH_PREVIEW_PUBLISHERS_FILTER';

export const FETCH_SEARCH_PREVIEW_OWNED_CONTENT = 'FETCH_SEARCH_PREVIEW_OWNED_CONTENT';
export const FETCHED_SEARCH_PREVIEW_OWNED_CONTENT = 'FETCHED_SEARCH_PREVIEW_OWNED_CONTENT';
export const SET_SEARCH_PREVIEW_OWNED_CONTENT_FILTER = 'SET_SEARCH_PREVIEW_OWNED_CONTENT_FILTER';

export const FETCH_SEARCH_PREVIEW_PAID_CONTENT = 'FETCH_SEARCH_PREVIEW_PAID_CONTENT';
export const FETCHED_SEARCH_PREVIEW_PAID_CONTENT = 'FETCHED_SEARCH_PREVIEW_PAID_CONTENT';
export const SET_SEARCH_PREVIEW_PAID_CONTENT_FILTER = 'SET_SEARCH_PREVIEW_PAID_CONTENT_FILTER';

export const PREFILL_CONTENT_SEARCH = 'PREFILL_CONTENT_SEARCH';
export const FETCH_ALL_SEARCHES = 'FETCH_ALL_SEARCHES';
export const CREATE_CONTENT_SEARCH = 'CREATE_CONTENT_SEARCH';
export const CLEAR_ALL_SEARCHES = 'CLEAR_ALL_SEARCHES';

/*  */
export const fetchKeywordsSearchPreview = (clear) => (dispatch, getState) =>
  fetchList({
    clear,
    dispatch,
    store: getState().SearchPreview.keywordsList,
    fetchingActionType: FETCH_SEARCH_PREVIEW_KEYWORDS,
    fetchedActionType: FETCHED_SEARCH_PREVIEW_KEYWORDS,
    apiCall: filters => keywords.getKeywordsList(filters),
  });

export const fetchBrandsSearchPreview = (clear) => (dispatch, getState) =>
  fetchList({
    clear,
    dispatch,
    store: getState().SearchPreview.brandsList,
    fetchingActionType: FETCH_SEARCH_PREVIEW_BRANDS,
    fetchedActionType: FETCHED_SEARCH_PREVIEW_BRANDS,
    apiCall: filters => brands.getBrandsList(filters),
  });

export const fetchPublishersSearchPreview = (clear) => (dispatch, getState) =>
  fetchList({
    clear,
    dispatch,
    store: getState().SearchPreview.publishersList,
    fetchingActionType: FETCH_SEARCH_PREVIEW_PUBLISHERS,
    fetchedActionType: FETCHED_SEARCH_PREVIEW_PUBLISHERS,
    apiCall: filters => publishers.getPublishersList(filters),
  });

export const fetchOwnedContentSearchPreview = (clear) => (dispatch, getState) =>
  fetchList({
    clear,
    dispatch,
    store: getState().SearchPreview.ownedContentList,
    fetchingActionType: FETCH_SEARCH_PREVIEW_OWNED_CONTENT,
    fetchedActionType: FETCHED_SEARCH_PREVIEW_OWNED_CONTENT,
    apiCall: filters => content.getContentList(filters),
  });

export const fetchPaidContentSearchPreview = (clear) => (dispatch, getState) =>
  fetchList({
    clear,
    dispatch,
    store: getState().SearchPreview.paidContentList,
    fetchingActionType: FETCH_SEARCH_PREVIEW_PAID_CONTENT,
    fetchedActionType: FETCHED_SEARCH_PREVIEW_PAID_CONTENT,
    apiCall: filters => content.getContentList(filters),
  });

/*  */
// export const fetchSearchPreview = (query) => (dispatch) =>
//   fetchPayload({
//     dispatch,
//     fetchingActionType: FETCH_SEARCH_PREVIEW,
//     fetchedActionType: FETCHED_SEARCH_PREVIEW,
//     apiCall: () => search.getSearchPreviewList(query),
//   });
